import { faHeadset, faHouse, faClipboardList, faWarehouse, faCogs, faSliders, faBoxOpen, faLayerGroup, faShieldHalved, faBoxesStacked, faCubes, faUsersGear } from '@fortawesome/free-solid-svg-icons'
import { USER_DATA } from 'src/app/_interfaces/auth.interface'


export const accessSessionTokenKeyName = 'access_token'
export const refreshSessionTokenKeyName = 'refresh_token'
export const loggedInUserDataKeyName = 'loggedInUser'
export const shopifyDetailsForOauth = 'shopifyDetailsForOauth'
export const shopifyDetailsForWithoutAuth = 'shopifyDetailsForWithoutAuth'
export const loggedInAdminAccessToken = 'loggedInAdminAccessToken'
export const loggedInAdminRefreshToken = 'loggedInAdminRefreshToken'
export const logOutHitCount = 'logOutHitCount'
export const checkUserToNavigateInPricing = 'checkUserToNavigateInPricing'
export const refreshOauthTokenData = 'refreshOauthTokenData'
export const handleRoutePathOnOauth = 'handleRoutePathOnOauth'  // only store the variables ''
export const tiktokPlatformData = 'tiktokPlatformData'  // store TIKTOK platform_data for post-registration API call
export const tiktokPlatformFinalizeRequestKey = 'tiktokPlatformFinalizeRequest'  // cache request payload sent to handle-app-after-installation for debugging
export const tiktokPlatformFinalizeResponseKey = 'tiktokPlatformFinalizeResponse'  // cache handle-app-after-installation response for debugging
export const walmartPlatformData = 'walmartPlatformData'  // store WALMART platform_data for post-registration API call
export const walmartPlatformFinalizeRequestKey = 'walmartPlatformFinalizeRequest'  // cache request payload sent to handle-app-after-installation for debugging
export const walmartPlatformFinalizeResponseKey = 'walmartPlatformFinalizeResponse'  // cache handle-app-after-installation response for debugging
export const walmartInstallationResponseKey = 'walmartInstallationResponse'  // cache Walmart callback response for debugging
export const walmartInstallationOpenGuardKey = 'walmartInstallationOpenGuard'  // prevent repeated callback tab opens for the same redirect


export const shopifyAccessScope = [
  { label: 'read_orders', value: 'read_orders' },
  { label: 'write_orders', value: 'write_orders' },
  { label: 'read_draft_orders', value: 'read_draft_orders' },
  { label: 'write_draft_orders', value: 'write_draft_orders' },
  { label: 'read_files', value: 'read_files' },
  { label: 'write_files', value: 'write_files' },
  { label: 'read_inventory', value: 'read_inventory' },
  { label: 'write_inventory', value: 'write_inventory' },
  { label: 'read_locales', value: 'read_locales' },
  { label: 'write_locales', value: 'write_locales' },
  { label: 'read_markets', value: 'read_markets' },
  { label: 'write_markets', value: 'write_markets' },
  { label: 'read_orders', value: 'read_orders' },
  { label: 'write_orders', value: 'write_orders' },
  { label: 'read_products', value: 'read_products' },
  { label: 'write_products', value: 'write_products' },
  { label: 'read_returns', value: 'read_returns' },
  { label: 'write_returns', value: 'write_returns' },
]

export const LANGUAGES_ENUM = [
  "ENGLISH",
  "SPANISH",
  "HINDI",
  "BENGALI",
  "PORTUGUESE",
  "RUSSIAN",
  "GERMAN",
  "FRENCH",
  "ITALIAN",
  "PUNJABI",
  "URDU",
  "PERSIAN",
  "GREEK",
  "POLISH",
  "DUTCH",
  "ROMANIAN",
  "CZECH",
  "SLOVAK",
  "SERBIAN",
  "CROATIAN",
  "BULGARIAN",
  "SLOVENIAN",
  "LITHUANIAN",
  "LATVIAN",
  "ALBANIAN",
  "ARMENIAN",
  "ICELANDIC",
  "IRISH",
  "WELSH",
  "SCOTS_GAELIC",
  "MANDARIN",
  "CANTONESE",
  "TIBETAN",
  "BURMESE",
  "MIN_NAN",
  "HAKKA",
  "WU",
  "HMONG",
  "ARABIC",
  "HEBREW",
  "AMHARIC",
  "SOMALI",
  "TIGRINYA",
  "HAUSA",
  "BERBER",
  "OROMO",
  "SWAHILI",
  "YORUBA",
  "IGBO",
  "SHONA",
  "ZULU",
  "XHOSA",
  "AKAN",
  "KIKUYU",
  "LINGALA",
  "WOLOF",
  "BEMBA",
  "FULA",
  "TWI",
  "TAGALOG",
  "JAVANESE",
  "MALAGASY",
  "FIJIAN",
  "SAMOAN",
  "MALAY",
  "INDONESIAN",
  "HAWAIIAN",
  "MAORI",
  "CHAMORRO",
  "TONGAN",
  "ILOCANO",
  "CEBUANO",
  "BIKOL",
  "TAMIL",
  "TELUGU",
  "KANNADA",
  "MALAYALAM",
  "TULU",
  "BRAHUI",
  "TURKISH",
  "AZERBAIJANI",
  "MONGOLIAN",
  "UZBEK",
  "KAZAKH",
  "KYRGYZ",
  "TATAR",
  "UYGHUR",
  "FINNISH",
  "HUNGARIAN",
  "ESTONIAN",
  "SAMI",
  "KOMI",
  "MARI",
  "KOREAN",
  "JAPANESE",
  "THAI",
  "LAO",
  "ZHUANG",
  "GEORGIAN",
  "CHECHEN",
  "ABKHAZ",
  "AVAR",
  "LEZGIN",
  "QUECHUA",
  "AYMARA",
  "NAVAJO",
  "GUARANI",
  "NAHUATL",
  "MAYA",
  "CHEROKEE",
  "INUIT",
  "PITJANTJATJARA",
  "WARLPIRI",
  "ARRENTE",
  "TOK_PISIN",
  "HULI",
  "ENGA",
  "AUSLAN",
  "PAPIAMENTO",
  "ESPERANTO",
  "KLINGON",
  "TOKI_PONA",
  "MANX",
  "CORNISH",
  "AINU",
  "YUCHI"
]

export const CONITION_EVALUATOR = [
  { "key": "EQUAL", "display_name": "Equal" },
  { "key": "NOT_EQUAL", "display_name": "Not Equal" },
  { "key": "CONTAINS", "display_name": "Contains" },
  { "key": "NOT_CONTAINS", "display_name": "Not Contains" },
  { "key": "GREATER_THAN_EQUAL", "display_name": "Greater Than Equal" },
  { "key": "SMALLER_THAN_EQUAL", "display_name": "Smaller Than Equal" },
  { "key": "START_WITH", "display_name": "Start With" },
  { "key": "END_WITH", "display_name": "End With" }
]

export const OPERATOR_MAP: Record<string, string[]> = {
  TEXT: [
    "EQUAL",
    "CONTAINS",
    "NOT_CONTAINS",
    "NOT_EQUAL",
    "END_WITH",
    "START_WITH",
  ],
  INTEGER: [
    "EQUAL",
    "NOT_EQUAL",
    "GREATER_THAN",
    "SMALLER_THAN",
    "GREATER_THAN_EQUAL",
    "SMALLER_THAN_EQUAL",
  ],
  SELECT: ["EQUAL", "NOT_EQUAL"],
  NONE: [],
  BOOLEAN: ["EQUAL", "NOT_EQUAL"],
  MULTILINETEXT: ["EQUAL", "CONTAINS", "NOT_CONTAINS", "NOT_EQUAL", "END_WITH", "START_WITH"]
};

export const USER_STAFF_ALLOWED_PATHS = [
  '/customers',
  '/support',
  '/account/settings',
];

export const ROUTES_NAMES = {
  "/orders-all": "sales_access",
  "/listing-product-table": "product_access",
  "/listing-product-table-old": "product_access",
  "/listing-product-table-ag": "product_access",
  "/listing-channels": "integration_access",
  "/platforms": "integration_access",
  "/bundles": "product_access",
  "/listing-profiles": "product_access",
  "/listing-profiles-old": "product_access",
  "/listing-profiles-previous": "product_access",
  "/template-and-pricing": "product_access",
  "/pricing": "billing_access",
  "/platform-setting-beta": "integration_access",
  "/manage-user-roles": "user_staff_management_access",
  "/manage-roles": "user_staff_management_access",
  "/account": "user_staff_management_access",
  "/rule-engine": "other_access",
  "/dashboard": "other_access",
  "/support": "other_access",
  "/products": "product_access",
  "/platform-setting": "integration_access",
  "/channel-settings": "integration_access",
  "/channel-settings-legacy": "integration_access",
}

// permissions.ts
export const PERMISSION_ROUTE_MAP = {
  customer_access: ['/dashboard'],
  report_access: ['/reports'],
  user_access: ['/manage-user', '/manage-roles'],
  manage_plan_access: ['/pricing-plans', '/manage-pricing'],
} as const

export type PermissionKey = keyof typeof PERMISSION_ROUTE_MAP


export const userStaffMenus = [
  {
    title: 'Dashboard',
    to: '/dashboard',
    icon: faHouse,
    permissionKey: 'other_access',
    moduleCheck: null
  },

  // ===== PRODUCTS =====
  {
    title: 'Products',
    to: '/products',
    icon: faBoxOpen,
    permissionKey: 'product_access',
    moduleCheck: 'isEnableProductModule'
    // children will be dynamically injected by renderUserStaffMenu
  },

  // ===== SALES =====
  {
    title: 'Sales',
    to: '/orders-all',
    icon: faClipboardList,
    permissionKey: 'sales_access',
    moduleCheck: null
  },

  // ===== INTEGRATIONS =====
  {
    title: 'Integrations',
    to: '/listing-channels',
    icon: faLayerGroup,
    permissionKey: 'integration_access',
    moduleCheck: null
  },

  // ===== TOOLS =====
  {
    title: 'Tools',
    to: '/rule-engine',
    icon: faSliders,
    permissionKey: 'other_access',
    moduleCheck: null
  },

  // ===== AUTOMATION =====
  // {
  //   title: 'Automation Rules',
  //   to: '/rule-engine',
  //   icon: faSliders,
  //   permissionKey: 'other_access',
  //   moduleCheck: null
  // },

  // ===== SUPPORT =====
  {
    title: 'Support',
    to: '/support',
    icon: faHeadset,
    permissionKey: 'support_access',
    moduleCheck: null
  },

  // User Management
  //  {
  //           to:'/manage-user-roles',
  //           icon:faUsersGear,
  //           title:'User Management',
  //               moduleCheck: null

  //  }
];

export const filteredUser: USER_DATA = {
  id: 1022,
  activation_token:
    "DbePJjHgOJaH0NMJjekRWdKw3jcdI9oh0eVCC8ZgQFov8JtNupfcw45IlUJFhBZKkrInxwqitjMutmsrYmQUkDkJt7xlrjR2bAxnLapzj31rfWWJPEOn0Jz4FqGUj03tY00P5IZ0fNdwLwnpMARHhjl5bgFIEwQLm3YARfh8cQGz3oUw9c2bwguY3iMfx12W5zvSNWEqokvdtYF3KqUvNmDztRrDQ0idPjja0rRYZ4pzZS0qLgFK5Mg3wa1cEWqs6t12ZEuuodGlGhoSe9ZdofEhiUVhTG1NyJAU58GFNKNrlJIv7pZI3B9qxStOnxbNleDG00MiaacAJihceXnKYDUFLyqyNE",
  date_joined: "2025-06-06T08:14:56.225452Z",
  email: "mbt15@gmail.com",
  forgot_password_token: null,
  isProcessing: false,
  is_active: true,
  is_superuser: false,
  last_login: null,
  last_processed: "2025-12-24T01:36:40.010425Z",
  name: null,
  parent: null,
  phoneNumber: null,
  isPhoneNumberStepDone: true,
  userAdditionalInfo: {
    id: 16,
    phone_number: "+919875484741",
    country: "India",
    mfa_enabled: false,
    mfa_setup_completed: true,
    mfa_secret: "IZET3BWLEKU5XZOPZDV27YHDOVXIVPCW",
    session_token: null,
    platform_connection_priority: "PRIMARY",
    user: 1022
  },
  password: null,
  source: "COMMERCIUM",
  user_type: "USER",
  invited_by: null,
  isPlatformInitProcessCompleted: false,
  isEnableProductModule: true,
  isOnboardingProcessCompleted: true,
  is_platform_choice_done: false,
  is_subscribed: true,
  hasCustomPlan: false,
  isStaffUser: false,
  company_name: "random company 11",
  gst_number: "",
  role: {},
  parent_user_role: {
    billing_access: "WRITE",
    customer_access: "WRITE",
    integration_access: "READ",
    other_access: "FULL",
    product_access: "WRITE",
    sales_access: "WRITE",
    support_access: "READ",
    user_staff_management_access: "FULL"
  },
  customer_ids: null,
  account_type: "DIRECT"
};

export const staffUser: USER_DATA = {
  id: 4595,
  activation_token: "ykeS3Ju3d0E38m68x515LK6Rtv7IHTxxTuvz2rBDPA0aoiX8yPP7iykDk26AsLUIk37pBx7xjZrbhknv7WNO5uqSjxJZ282YCMIKfb3KRGvsCiDmIenql7q6dTYd8xY89jPR5pSviLPN5CbYAzV09OrOmVgqUW5XIwTrs8LcXdrDFGS8E4hT8dIKK8PLNf1mNND9mAMu1ZI6QDhdkjM799yOTJ2zU0KHSb3a8zLwvpJhULafhf6rOnkR3m6IKkKGmUMEaHeFkkEJyP7LQQu9YnfyPDWBwXgcHdTdy3kp6npe15TMDP2hnesHGcCm5vs8ag9rC21Auo2x1yUYOQRCnc1OqrJczg",
  date_joined: "2025-01-22T05:48:59.758426Z",
  email: "mbtawadhesh@gmail.com",
  forgot_password_token: null,
  isProcessing: false,
  is_active: true,
  is_superuser: false,
  last_login: null,
  last_processed: "2025-12-04T04:49:16.933560Z",
  name: null,
  parent: null,
  phoneNumber: null, // original is "+", so converted to null
  isPhoneNumberStepDone: true,
  userAdditionalInfo: {
    id: 4532,
    phone_number: "+",
    country: null,
    mfa_enabled: false,
    mfa_setup_completed: false,
    mfa_secret: null,
    session_token: null,
    platform_connection_priority: null,
    user: 4595
  },
  password: null,
  source: "COMMERCIUM",
  user_type: "USER",
  invited_by: null,
  isPlatformInitProcessCompleted: false,
  isEnableProductModule: true,
  timezone: null,
  isOnboardingProcessCompleted: true,
  is_platform_choice_done: false,
  is_subscribed: true,
  hasCustomPlan: false,
  isStaffUser: true,
  company_name: null,
  gst_number: null,
  role: {
    id: 17,
    name: "Admin (Full Access)",
    customer_access: "READ",
    manage_plan_access: "RESTRICT",
    report_access: "RESTRICT",
    user_access: "RESTRICT",
    is_active: true,
    is_deleted: false,
    created_at: "2026-01-20T11:53:18.325908Z",
    updated_at: "2026-01-29T10:58:59.709077Z",
    user: 654,
    created_by: 654,
    flow_and_permissions: {
      billing_access: "FULL",
      integration_access: "FULL",
      other_access: "FULL",
      product_access: "FULL",
      sales_access: "FULL",
      support_access: "READ",
      user_staff_management_access: "FULL"
    },
    billing_access: "FULL",
    integration_access: "FULL",
    other_access: "FULL",
    product_access: "FULL",
    sales_access: "FULL",
    support_access: "READ",
    user_staff_management_access: "FULL"
  },
  parent_user_role: null, // not provided in JSON, set to null
  customer_ids: "654",
  account_type: "USER_STAFF"
};

export const userData: USER_DATA = {
  id: 654,
  activation_token: "ykeS3Ju3d0E38m68x515LK6Rtv7IHTxxTuvz2rBDPA0aoiX8yPP7iykDk26AsLUIk37pBx7xjZrbhknv7WNO5uqSjxJZ282YCMIKfb3KRGvsCiDmIenql7q6dTYd8xY89jPR5pSviLPN5CbYAzV09OrOmVgqUW5XIwTrs8LcXdrDFGS8E4hT8dIKK8PLNf1mNND9mAMu1ZI6QDhdkjM799yOTJ2zU0KHSb3a8zLwvpJhULafhf6rOnkR3m6IKkKGmUMEaHeFkkEJyP7LQQu9YnfyPDWBwXgcHdTdy3kp6npe15TMDP2hnesHGcCm5vs8ag9rC21Auo2x1yUYOQRCnc1OqrJczg",
  date_joined: "2025-01-22T05:48:59.758426Z",
  email: "mbt@gmail.com",
  forgot_password_token: null,
  isProcessing: false,
  is_active: true,
  is_superuser: false,
  last_login: null,
  last_processed: "2025-12-04T04:49:16.933560Z",
  name: null,
  parent: null,
  phoneNumber: null, // original phone_number is '+', so you may convert to number or null
  isPhoneNumberStepDone: true,
  userAdditionalInfo: {
    ...{
      id: 363,
      phone_number: "+",
      country: null,
      mfa_enabled: false,
      mfa_setup_completed: false,
      mfa_secret: null,
      session_token: null,
      platform_connection_priority: "PRIMARY",
      user: 654,
    }
  },
  password: null,
  source: "COMMERCIUM",
  user_type: "USER",
  invited_by: null,
  isPlatformInitProcessCompleted: false,
  isEnableProductModule: true,
  timezone: null,
  isOnboardingProcessCompleted: true,
  is_platform_choice_done: true,
  is_subscribed: true,
  hasCustomPlan: false,
  isStaffUser: false,
  company_name: null,
  gst_number: null,
  role: {}, // as per original
  parent_user_role: {
    billing_access: "READ",
    customer_access: "READ",
    integration_access: "READ",
    manage_plan_access: "READ",
    other_access: "READ",
    product_access: "READ",
    report_access: "READ",
    sales_access: "READ",
    support_access: "READ",
    user_access: "READ",
    user_staff_management_access: "RESTRICT"
  },
  customer_ids: null,
  account_type: "DIRECT",
};


export const dummyConditionList = [
  {
    id: 2,
    display_name: "If Order LineItem Quantity",
    condition_code: "CHECK_ORDER_LINE_ITEM_QUANTITY",
    input_type: "INTEGER",
    field_type: "LOCAL",
    description: "hello bhawana"
  },
  {
    id: 4,
    display_name: "If Order LineItem SKU",
    condition_code: "CHECK_ORDER_LINE_ITEM_SKU",
    input_type: "TEXT",
    field_type: "LOCAL",
    description: "hello bhawana"
  },
  {
    id: 13,
    display_name: "If Order Total LineItem Count",
    condition_code: "CHECK_ORDER_TOTAL_LINE_ITEM_COUNT",
    input_type: "INTEGER",
    field_type: "NATIVE",
    description: "hello bhawana"
  },
  {
    id: 7,
    display_name: "If Order Total LineItem Quantity",
    condition_code: "CHECK_ORDER_TOTAL_LINE_ITEM_QUANTITY",
    input_type: "INTEGER",
    field_type: "LOCAL",
    description: "hello bhawana"
  },
  {
    id: 1,
    display_name: "If Order Total Value",
    condition_code: "CHECK_ORDER_TOTAL_PRICE",
    input_type: "INTEGER",
    field_type: "LOCAL",
    description: "hello bhawana"
  },
  {
    id: 14,
    display_name: "If Product type of Order line item is Bundle",
    condition_code: "CHECK_ORDER_BUNDLE_LINE_ITEM_EXIST",
    input_type: "NONE",
    field_type: "NATIVE",
    description: "hello bhawana"
  }
]
export interface Condition {
  id: number
  display_name: string
  condition_code: string
  input_type: string
  field_type: string
  description: string
}

export const ERP_BASE = "/erp";
export const OMS_BASE = "/oms";

export const OWNER_OPTIONS: { label: string; value: string }[] = [
  { label: "ORDER", value: "ORDER" },
  { label: "PRODUCT", value: "PRODUCT" },
  // { label: "SHIPMENT", value: "SHIPMENT" },
  // { label: "CUSTOMER", value: "CUSTOMER" },
  // { label: "VENDOR", value: "VENDOR" },
  // { label: "INVENTORY", value: "INVENTORY" },
  { label: "PRODUCT VARIANT", value: "PRODUCTVARIANT" },
];
export const DATA_TYPES = ["TEXT", "SELECT", "MULTISELECT", "CHECKBOX", "NUMBER", "EMAIL", "URL", "DATE", "DATE_TIME", "TIME"];

export const defaultConsent = {
  necessary: true,
  analytics: false,
  preferences: false,
  marketing: false,
};

export const STORAGE_KEY = "cookie-consent";

export const WEIGHT_UNIT_OPTIONS = [
  { value: 'KGS', label: 'KGS' },
  { value: 'GMS', label: 'GMS' },
  { value: 'LBS', label: 'LBS' },
  { value: 'OZS', label: 'OZS' },
  { value: 'MGS', label: 'MGS' },
  { value: 'TONS', label: 'TONS' },
  { value: 'MLS', label: 'MLS' },
]

export const DIMENSION_UNIT_OPTIONS = [
  { value: 'MM', label: 'MM' },
  { value: 'CM', label: 'CM' },
  { value: 'M', label: 'M' },
  { value: 'IN', label: 'IN' },
  { value: 'FT', label: 'FT' },
  { value: 'YD', label: 'YD' },
]

export const currencySigns = {
  USD: '$', // United States Dollar
  INR: '₹', // Indian Rupee
  AUD: 'A$', // Australian Dollar
  AU: 'A$', // Australia (same as AUD)
  GBP: '£', // British Pound Sterling
  EUR: '€', // Euro
  NZD: 'NZ$', // New Zealand Dollar
  CAD: '$', // Canadian Dollar
  CHF: 'CHF', // Swiss Franc
  SEK: 'kr', // Swedish Krona
  KRW: '₩', // South Korean Won
  JPY: '¥', // Japanese Yen
  HUF: 'Ft', // Hungarian Forint
  NOK: 'kr', // Norwegian Krone
  DKK: 'kr', // Danish Krone
  KWD: 'د.ك', // Kuwaiti Dinar
  NPR: '₨', // Nepalese Rupee
  ILS: '₪', // Israeli New Shekel
  EGP: 'ج.م', // Egyptian Pound
  PLN: 'zł', // Polish Zloty
  MXN: '$', // Mexican Peso
  AED: 'د.إ', // UAE Dirham
  SAR: 'ر.س', // Saudi Riyal
  TRY: '₺', // Turkish Lira
  MYR: 'RM', // Malaysian Ringgit
  HKD: '$', // Hong Kong Dollar
  CZK: 'Kč', // Czech Koruna
  RON: 'lei', // Romanian Leu
  SGD: '$', // Singapore Dollar
  ZAR: 'R', // South African Rand
  MAD: 'د.م.', // Moroccan Dirham
  BGN: 'лв', // Bulgarian Lev
  UGX: 'USh', // Ugandan Shilling
}


export const normalizeWeightUnit = (unit: string | undefined | null) => {
  if (!unit) return 'GMS'
  const u = unit.toUpperCase().trim()
  if (['MG', 'MSG', 'MGS'].includes(u)) return 'MGS'
  if (['G', 'GM', 'GMS'].includes(u)) return 'GMS'
  if (['KG', 'KGS'].includes(u)) return 'KGS'
  if (['OZ', 'OZS'].includes(u)) return 'OZS'
  if (['LB', 'LBS'].includes(u)) return 'LBS'
  if (['TON', 'TONS'].includes(u)) return 'TONS'
  if (['ML', 'MLS'].includes(u)) return 'MLS'
  return u
}

export const normalizeDimensionUnit = (unit: string | undefined | null) => {
  if (!unit) return 'CM'
  const u = unit.toUpperCase().trim()
  if (['MMS'].includes(u)) return 'MM'
  if (['CMS'].includes(u)) return 'CM'
  if (['INCH'].includes(u)) return 'IN'
  if (['FOOT'].includes(u)) return 'FT'
  if (['YARD'].includes(u)) return 'YD'
  return u
}
